import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

/**
 * Replicates AngularJS adminResetDsConnectionService.resetDsConnection.
 * GET {baseUrl}/resetDataSourceConnection?datasource=...&refreshFromDB=...
 * baseUrl is chosen by api param: gtw -> base_url, admin -> admin_api_url, etc.
 */
@Injectable({ providedIn: 'root' })
export class AdminResetDsConnectionService {

  constructor(private http: HttpClient) {}

  getBaseUrl(api: string, generalConfig: any): string {
    if (!generalConfig) return '';
    switch (api) {
      case 'gtw': return generalConfig.base_url || '';
      case 'admin': return generalConfig.admin_api_url || '';
      case 'common': return generalConfig.common_api_url || '';
      case 'custom': return generalConfig.custom_api_url || '';
      case 'scheduler': return generalConfig.scheduler_api_url || '';
      case 'efile': return generalConfig.gtw_efile_api_url || '';
      case 'bulkpdf': return generalConfig.bulk_pdf_engine_api_url || '';
      case 'pdf': return generalConfig.pdf_engine_api_url || '';
      default: return generalConfig.base_url || '';
    }
  }

  resetDsConnection(params: { api: string; client_key?: string; datasource: string; refreshFromDB: boolean }, generalConfig: any): Observable<any> {
    const baseUrl = this.getBaseUrl(params.api, generalConfig);
    const url = `${baseUrl}/resetDataSourceConnection?datasource=${encodeURIComponent(params.datasource)}&refreshFromDB=${params.refreshFromDB}`;
    return this.http.get(url, { withCredentials: true });
  }

  purgeConnections(params: { api: string; datasource?: string; includeCoreDS: boolean }, generalConfig: any): Observable<any> {
    const baseUrl = this.getBaseUrl(params.api, generalConfig);
    let url = `${baseUrl}/purgeDataSourceConnections?includeCoreDS=${params.includeCoreDS}`;
    if (params.datasource) {
      url += `&datasource=${encodeURIComponent(params.datasource)}`;
    }
    return this.http.get(url, { withCredentials: true });
  }
}
